import { useState } from "preact/hooks";
import { Button } from "../../components";
import type { Card } from "../../content/types";

export function Recall({ content, onDone }: { content: Card; onDone: () => void }) {
  const [revealed, setRevealed] = useState(false);

  if (!revealed) {
    return (
      <div class="stage stage-recall">
        <p class="stage-kicker">Say it out loud, right now</p>
        <p class="display stage-lead">{content.scenario}</p>
        <Button size="lg" onClick={() => setRevealed(true)}>
          I said something
        </Button>
      </div>
    );
  }

  return (
    <div class="stage stage-recall">
      <p class="stage-kicker">Be honest — the dojo sees all</p>
      <div class="display stage-lead">{content.text}</div>
      {content.meaning && <p class="stage-detail">{content.meaning}</p>}
      <Button size="lg" onClick={onDone}>
        Continue
      </Button>
    </div>
  );
}
